export default "__VITE_ASSET__13a95f34__"